import { render, staticRenderFns } from "./customFields.vue?vue&type=template&id=489adf71&"
import script from "./customFields.vue?vue&type=script&lang=js&"
export * from "./customFields.vue?vue&type=script&lang=js&"
import style0 from "./customFields.vue?vue&type=style&index=0&id=489adf71&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports